export default function () {
  this.doLoadItem()
}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/next-patient/resources/mounted.js